import type { ConditionProperty } from '@/tools/conditionWithProperties/conditionWithProperties.types';

export const DEFAULT_PROPERTY_CONFIG: ConditionProperty = {
  stringSignal: '',
  propertyName: '',
};

export const INITIAL_PROPERTIES: ConditionProperty[] = [{ ...DEFAULT_PROPERTY_CONFIG }, { ...DEFAULT_PROPERTY_CONFIG }];
